import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {KitchenDashboardService} from './kitchen-dashboard.service';
import {KitchenDashboardComponent} from './components/kitchen-dashboard.component';
import {KitchenSharedModule} from '../shared/kitchen-shared.module';
import {KnDashboardTableComponent} from './components/kn-dashboard-table.component';
import {KnDashboardMetricBoxesComponent} from './components/kn-dashboard-metric-boxes.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {KnDashboardWidgetsComponent} from './components/kn-dashboard-widgets.component';
import {KitchenDashboardMainWidgetsComponent} from './main/kn-dashboard-main-widgets.component';

@NgModule({
  imports: [
    // RouterModule.forChild(kitchenDashboardRoutes),
    RouterModule,
    KitchenSharedModule,
    BrowserAnimationsModule,
  ],
  declarations: [
    KitchenDashboardComponent,
    KnDashboardTableComponent,
    KnDashboardMetricBoxesComponent,
    KnDashboardWidgetsComponent,
    KitchenDashboardMainWidgetsComponent
  ],
  providers: [
    KitchenDashboardService,
  ],
  exports: [
    RouterModule
  ]
})
export class KitchenDashboardModule {
}
